// extracted by mini-css-extract-plugin
export default {"title-section":"iE8tk3w_s3","titleSection":"iE8tk3w_s3","not-available":"beN_fnnc_J","notAvailable":"beN_fnnc_J"};